import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './Admin Panel/AuthContext'; // ✅ Import the provider

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider> {/* ✅ Wrap your App in AuthProvider */}
      <App />
    </AuthProvider>
  </React.StrictMode>
);
